import { Component, OnInit } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { OrderMenu } from '../../_models/orderMenu';
import { Subject } from 'rxjs';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { User } from '../../_models/user';
import { AccessSecurity } from '../../_models/accessSecurity';
import { Globals } from '../../_models/globals';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiIntegration } from '../../_services/api.integration';
import { AlertService } from '../../_services/alert.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { environment } from '../../../environments/environment';
import { saveAs } from 'file-saver';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-shipment-list',
  templateUrl: './shipment-list.component.html',
  styleUrls: ['./shipment-list.component.css'],
  providers: [DatePipe]
})

export class ShipmentListComponent implements OnInit {
  ordersMainMenu: OrderMenu[] = [
    { displayName: "Delivered", tabClicked: "Delivered", orderStatus: "DELIVERED", additional: "N" },
    { displayName: "RTO (Return to Origin)", tabClicked: "RTO", orderStatus: "RTO", additional: "N" }
  ];

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtInstance: DataTables.Api;
  dtTrigger = new Subject();
  statusText1: string = "";
  userDrop2: any = 'DELIVERED';
  orderStatus: any = 'DELIVERED';
  tabClicked: any;
  shipments: any;
  ohid: any;
  pdfGenerate: string = 'N';
  unHoldActivities: string = 'N';
  loadingCompleted = false;
  totalCount = 0;
  masterSelected: boolean = false;
  checkedList = [];
  cancelReasons: string;
  loading = true;
  checkedList2 = [];
  checkedOrderIdList = [];
  checkedListView = [];
  cancelActivities: string = 'N';
  holdActivities: string = 'N';
  activityDetails: string;
  errorMessage: string = "";
  previousStatus = '';
  totalRecords: number;
  errorMessage2: string = "";
  toDayDateAndTime = new Date().toLocaleString();
  reason: string;
  size: string;
  sizeError: string;
  awb: any = {
    tracking_data: "",
    track_status: "",
    shipment_status: "",
    shipment_track: [],
    shipment_track_activities: []
  };

  constructor(public accessSec: AccessSecurity, private datePipe: DatePipe, private alertService: AlertService, private http: HttpClient, private api: ApiIntegration, private router: Router, private route: ActivatedRoute, public user: User, public g: Globals) {
    setInterval(() => {
      this.toDayDateAndTime = this.datePipe.transform(new Date(), 'dd-MM-yyyy HH:mm:ss');
    }, 1000);
    if (this.g.pageTab !== null && this.g.pageTab !== undefined) {
      this.tabClicked = this.g.pageTab;
      let index = this.ordersMainMenu.findIndex((d) => d.tabClicked === this.g.pageTab);
      if (index > -1) {
        if (this.tabClicked !== "all") {
          this.getOrderCount();
        }
        for (let ol of this.ordersMainMenu) {
          if (ol.tabClicked === this.g.pageTab) {
            this.populateTabData(this.g.pageTab, ol.orderStatus);
            this.switchPosition(ol);
          }
        }
      } else {
        this.tabClicked = "Delivered";
        this.populateTabData('Delivered', "DELIVERED");
      }
    } else {
      this.tabClicked = "Delivered";
      this.populateTabData('Delivered', "DELIVERED");
    }
  }

  tabChange() {
    this.checkedList = [];
    this.g.loaderDisplay = "display";
  }

  populate(orderChange) {
    this.api.getShipmentsByAdmin(orderChange, "1").subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.shipments = data.shipmentData;
    }, err => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error', err);
    });
  }

  selectShip(sl) {
    if (!sl.isSelected) {
      this.masterSelected = false;
    }
    this.getCheckedShipList();
  }

  splice(i, id) {
    let index = this.shipments.findIndex((d) => d.shipmentHeaderId === id);
    if (index > -1) {
      this.shipments[index].isSelected = false;
    }
    this.checkedList2.splice(index, 1);
    this.checkedOrderIdList.splice(index, 1);
    this.checkedListView.splice(index, 1);
  }

  getOrderCount() {
    this.loading = true;
    if (this.user.role == 'ACCOUNT_OWNER' || this.user.role === 'ROLE_USER' || this.user.role === 'DEMO_ACCOUNT') {
      this.api.getShipmentsByAdmin("ALL", this.user.organizationId).subscribe((data: any) => {
        if (data) {
          this.totalCount = data.noOfRecords;
          this.loading = false;
        }
      }, err => {
        this.alertService.error('Error', err);
      });
    } else {
      this.api.getShipmentsByAdmin("ALL", "1").subscribe((data: any) => {
        if (data) {
          this.totalCount = data.noOfRecords;
          this.loading = false;
        }
      }, err => {
        this.alertService.error('Error', err);
      });
    }
  }

  switchPosition(om) {
    let index = this.ordersMainMenu.indexOf(om);
    om.additional = 'N';
  }

  populateTabData(triggered, orderStatus) {
    this.tabClicked = triggered;
    this.orderStatus = orderStatus;
    if (!this.previousStatus) {
      this.getOrdersByStatus(orderStatus);
    } else {
      this.rerender();
    }
  }

  resetCheckedList() {
    this.masterSelected = false;
    this.checkedList2 = [];
    this.checkedOrderIdList = [];
    this.checkedListView = [];
    this.errorMessage = '';
  }

  cancelOrderPopUp(shipments) {
    let i = 0;
    let ohid;
    for (let shipment of shipments) {
      if (shipment.isSelected) {
        i = i + 1;
        ohid = shipment.shipmentHeaderId;
      }
    }
    ;
    if (i === 1) {
      this.cancelActivities = 'Y';
      this.getReasons();
    }
  }

  generateManifest(shipmentIds) {
    var headerInfo = new HttpHeaders();
    headerInfo = headerInfo.append('Content-Type', 'application/json');
    headerInfo = headerInfo.append('Accept', 'application/pdf');
    headerInfo = headerInfo.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));

    this.http.post(environment.apiUrl + 'api/generateManifestPdfForStock', {
      "accountOwnerId": this.user.accountOwnerId,
      "headerIds": shipmentIds,
      "organizationId": this.user.organizationId,
      "size": "A4"
    },
      { responseType: 'blob', headers: headerInfo }).subscribe((resp: any) => {
        this.g.loaderDisplay = "";
        var mediaType = 'application/pdf';
        var blob = new Blob([resp], { type: mediaType });
        var filename = 'shipment_manifest_A4_' + this.toDayDateAndTime + '.pdf';
        saveAs(blob, filename);
        this.alertService.success('Success', 'Manifest generated successfully');
      }, err => {
        this.g.loaderDisplay = "";
        console.log(err);
        this.alertService.error('Error', err);
      });
  }

  generateShippingLabel(shipments) {
    let i = 0;
    for (let shipment of shipments) {
      if (shipment.isSelected) {
        i = i + 1;
        this.ohid = shipment;
      }
    }
    ;
    if (i === 1) {
      if (this.ohid.thirdPartyShippingLabelUrl !== null) {
        this.navigateShippingUrl(shipments);
      } else {
        this.pdfGenerate = 'Y';
      }
    } else {
      this.errorMessage = "Can not ship multiple orders at once. Please select one at a time";
    }
  }

  close() {
    this.pdfGenerate = 'N';
    this.size = '';
  }

  getOrdersByStatus(status) {
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.dtOptions = {
      "ordering": false,
      pagingType: 'full_numbers',
      lengthMenu: [20, 50, 100, 200],
      pageLength: 20,
      serverSide: true,
      language: {
        searchPlaceholder: 'Search by Shipment #'
      },
      ajax: (dataTablesParameters: any, callback) => {
        if (this.previousStatus !== this.orderStatus) {
          dataTablesParameters.start = 0;
          this.previousStatus = this.orderStatus;
        }
        let query: any = {
          status: this.orderStatus,
          organizationId: 1
        }
        if ((dataTablesParameters.search || {}).value && (dataTablesParameters.search || {}).value.trim() !== '') {
          query.searchString = dataTablesParameters.search.value.trim();
        }
        if (this.user.role == 'ACCOUNT_OWNER' || this.user.role === "ROLE_USER" || this.user.role == 'DEMO_ACCOUNT') {
          query.accountOwnerId = this.user.accountOwnerId;
        }
        this.g.loaderDisplay = "display";
        this.loadingCompleted = false;
        this.http.get(environment.apiUrl + "api/getAllShipmentData", {
          params: query,
          headers: header1
        }).subscribe((resp: any) => {
          this.shipments = resp.shipmentData;
          this.g.loaderDisplay = "";
          this.loadingCompleted = true;
          if (this.orderStatus === 'DELIVERED' && !query.searchString) {
            this.totalCount = resp.noOfRecords;
          }
          this.totalRecords = resp.noOfRecords;
          this.shipments.forEach((s) => {
            s['isSelected'] = false;
          });
          callback({
            recordsTotal: resp.noOfRecords,
            recordsFiltered: resp.noOfRecords
          });
        },
          (err) => {
            this.g.loaderDisplay = "";
            this.loadingCompleted = true;
            this.alertService.error('Error', err);
          });
      }
    };
  }

  holdMultiOrders(shipments) {
    for (let shipment of shipments) {
      if (shipment.isSelected) {
        this.holdOrder(shipment);
      }
    }
    ;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(true);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(true);
    });
  }

  submitOrder() {
    this.router.navigate(['/admin/createOrders']);
  }

  holdOrderPopUp(p) {
    if ((this.checkedList2 || []).length == 1) {
      this.holdMultiOrders(p)
    } else {
      this.holdActivities = 'Y';
    }
  }

  getCheckedShipList() {
    this.checkedList2 = [];
    this.checkedOrderIdList = [];
    this.checkedListView = [];
    for (var i = 0; i < (this.shipments || []).length; i++) {
      if (this.shipments[i].isSelected) {
        this.checkedList2.push(this.shipments[i]['sourceOrderId']);
        this.checkedOrderIdList.push(this.shipments[i]['sourceOrderId']);
        this.checkedListView.push(this.shipments[i]);
      }
    }
  }

  cancelMultiOrders(shipments) {
    for (let shipment of shipments) {
      if (shipment.isSelected) {
        this.cancelOrder(shipment);
      }
    }
    ;
  }

  closePopUp() {
    this.cancelActivities = 'N';
    this.activityDetails = "";
  }

  closePopUpHold() {
    this.holdActivities = 'N';
    this.activityDetails = "";
  }

  closePopUpUnHold() {
    this.unHoldActivities = 'N';
    this.activityDetails = "";
  }

  returnOrders(shipments) {
    this.router.navigate(['/admin/returnOrder/' + this.checkedList2[0]]);
  }

  getReasons() {
    this.api.getValues("1", 'OUTBOUND', 'CANCEL_REASON', 'Shipments').subscribe((data: any) => {
      this.cancelReasons = data.tripleSetConfigDTOS;
    }, err => {
      console.log(err);
    });
  }

  holdOrder(ord) {
  }

  cancelOrder(ord) {
  }

  printShipment() {
    console.log(this.ohid)

    this.sizeError = "";

    if (!this.size) {
      this.sizeError = 'Please select size';
    }

    if (this.sizeError != "") {
      return false;
    }

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/pdf');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.g.loaderDisplay = "display";
    this.http.post(environment.apiUrl + 'api/generateShippingLabelPdfForStock', {
      "headerId": this.ohid.sourceOrderId,
      "organizationId": this.user.organizationId,
      "accountOwnerId": this.ohid.accountOwnerId,
      "size": this.size
    },
      { responseType: 'blob', headers: header1 }).subscribe((resp: any) => {
        console.log(resp);
        var mediaType = 'application/pdf';
        var blob = new Blob([resp], { type: mediaType });
        var filename = 'ib_' + this.ohid.sourceOrderId + '_shipping_label_' + this.size + '_' + this.toDayDateAndTime + '.pdf';
        saveAs(blob, filename);
        this.g.loaderDisplay = "";
        this.pdfGenerate = 'N';
        this.size = "";
        this.populateTabData('Delivered', "DELIVERED");
      },
        (err) => {
          this.g.loaderDisplay = "";
          this.alertService.error('Error', err);
        });
  }

  navigateShippingUrl(shipments) {
    let i = 0;
    for (let shipment of shipments) {
      if (shipment.isSelected) {
        i = i + 1;
        this.ohid = shipment;
      }
    }
    ;
    if (i == 1) {
      let j = 0;
      for (j = 0; j < this.ohid.thirdPartyShippingLabelUrl.length; j++) {
        window.open(this.ohid.thirdPartyShippingLabelUrl[j], '_blank')
      }
    }
  }
}
